import axiosInstance from './axios';
import { API_ENDPOINTS } from './config';
import { ApiError } from './error';
import {
    DataCriteriaCreateType,
    DataCriteriaResponseType,
    DataCriteriaGroupResponseType,
    DataCriteriaBulkUpdateType,
    CriteriaType
} from '@/types/dataCriteria';

/**
 * 모든 데이터 기준 조회
 */
export async function getAllDataCriteriaApi(): Promise<DataCriteriaGroupResponseType[]> {
    try {
        const response = await axiosInstance.get<DataCriteriaGroupResponseType[]>(
            API_ENDPOINTS.DATA_CRITERIA.LIST
        );
        return response;
    } catch (error) {
        throw ApiError.fromAxiosError(error);
    }
}

/**
 * 특정 타입의 데이터 기준 조회
 */
export async function getDataCriteriaByTypeApi(
    criteriaType: CriteriaType
): Promise<DataCriteriaGroupResponseType> {
    try {
        const response = await axiosInstance.get<DataCriteriaGroupResponseType>(
            API_ENDPOINTS.DATA_CRITERIA.BY_TYPE(criteriaType)
        );
        return response;
    } catch (error) {
        throw ApiError.fromAxiosError(error);
    }
}

/**
 * 데이터 기준 생성
 */
export async function createDataCriteriaApi(
    data: DataCriteriaCreateType
): Promise<DataCriteriaResponseType> {
    try {
        const response = await axiosInstance.post<DataCriteriaResponseType>(
            API_ENDPOINTS.DATA_CRITERIA.CREATE,
            data
        );
        return response;
    } catch (error) {
        throw ApiError.fromAxiosError(error);
    }
}

/**
 * 데이터 기준 수정
 */
export async function updateDataCriteriaApi(
    id: number,
    data: DataCriteriaCreateType
): Promise<DataCriteriaResponseType> {
    try {
        const response = await axiosInstance.put<DataCriteriaResponseType>(
            API_ENDPOINTS.DATA_CRITERIA.UPDATE(id),
            data
        );
        return response;
    } catch (error) {
        throw ApiError.fromAxiosError(error);
    }
}

/**
 * 타입별 일괄 업데이트
 */
export async function bulkUpdateDataCriteriaApi(
    data: DataCriteriaBulkUpdateType
): Promise<DataCriteriaResponseType[]> {
    try {
        const response = await axiosInstance.put<DataCriteriaResponseType[]>(
            API_ENDPOINTS.DATA_CRITERIA.BULK_UPDATE,
            data
        );
        return response;
    } catch (error) {
        throw ApiError.fromAxiosError(error);
    }
}

/**
 * 데이터 기준 삭제
 */
export async function deleteDataCriteriaApi(id: number): Promise<void> {
    try {
        await axiosInstance.delete(API_ENDPOINTS.DATA_CRITERIA.DELETE(id));
    } catch (error) {
        throw ApiError.fromAxiosError(error);
    }
}

/**
 * 활성화/비활성화
 */
export async function updateActiveStatusApi(
    id: number,
    isActive: boolean
): Promise<void> {
    try {
        await axiosInstance.patch(
            API_ENDPOINTS.DATA_CRITERIA.UPDATE_ACTIVE(id),
            null,
            { params: { isActive } }
        );
    } catch (error) {
        throw ApiError.fromAxiosError(error);
    }
}

/**
 * 타입별 활성화/비활성화
 */
export async function updateActiveStatusByTypeApi(
    criteriaType: CriteriaType,
    isActive: boolean
): Promise<void> {
    try {
        await axiosInstance.patch(
            API_ENDPOINTS.DATA_CRITERIA.UPDATE_ACTIVE_BY_TYPE(criteriaType),
            null,
            { params: { isActive } }
        );
    } catch (error) {
        throw ApiError.fromAxiosError(error);
    }
}

// API_ENDPOINTS에 추가해야 할 엔드포인트
export const DATA_CRITERIA_ENDPOINTS = {
    LIST: '/api/data-criteria',
    CREATE: '/api/data-criteria',
    BY_TYPE: (type: CriteriaType) => `/api/data-criteria/type/${type}`,
    UPDATE: (id: number) => `/api/data-criteria/${id}`,
    DELETE: (id: number) => `/api/data-criteria/${id}`,
    BULK_UPDATE: '/api/data-criteria/bulk-update',
    UPDATE_ACTIVE: (id: number) => `/api/data-criteria/${id}/active`,
    UPDATE_ACTIVE_BY_TYPE: (type: CriteriaType) => `/api/data-criteria/type/${type}/active`
};